import React, { useContext } from "react";

import { Link } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Functions from "../../utility/services/Functions";
import { AuthContext } from "../../utility/services/AuthContext";
import AOS from "aos";
import Gradient1IMG from "../images/newimg/gradient2.jpg";

const BannerNewSection = (props) => {
  //////////////////////////////////// LOGICAL VARIABLES ///////////////////////////////////////////////
  // LOGICAL VARIABLES
  React.useEffect(() => {
    AOS.init({
      // ... your other initialisation options here ...
      once: true,
    });
  }, []);
  const { consoleService } = Functions();
  const { user } = useContext(AuthContext);

  const isUserDetails = user.details != null;
  const role = isUserDetails ? user.details.role : "";

  /////////////////////////////////////////// DATA VARIABLES //////////////////////////////////////////////

  const { title } = props;

  /////////////////////////////////////////// FUNCTIONS /////////////////////////////////////////////////

  const naviage_to = () => {
    if (isUserDetails) {
      if (role == "Therapist") {
        return "/dashboard";
      } else if (role == "Patient") {
        return "/dashboard";
      } else {
        return "/";
      }
    } else {
      return "/";
    }
  };

  return (
    <div
      className="breadcrumbmain_div breadcrumbmain_div1"
      style={{ backgroundImage: `url(${Gradient1IMG})`, ...props.style }}
    >
      <div className="container">
        <div className="row">
          <div className="colxl-12 col-lg-12 col-md-12">
            <h1
              className="ft-medium fw-bold"
              data-aos="zoom-in"
              data-aos-duration="1000"
              data-aos-delay="50"
            >
              {props.title}
            </h1>
            <p
              className="text-center"
              style={{ width: "100%", maxWidth: 800, margin: "0 auto 20px" }}
            >
              Mind Matters: Exploring the Latest News, Research, and Personal
              Stories on Mental Health, Wellness, Self-Care, Therapy, and
              Emotional Well-being to Support a Balanced, Resilient, and
              Healthier Life Every Day
              {/* Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
              vulputate libero et <br /> velit interdum, ac aliquet odio mattis. */}
            </p>
            {props.tabs}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerNewSection;
